<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Leads Keyword Report</h1>
        </div>
    </div>
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-3 mt-2"><input class="form-control" [(ngModel)]="search" type="text" (keyup)="loadleads(0,perpage)" placeholder="Search" /></div>

                        <div class="col-sm-3 mt-2">
                            <mat-select  placeholder="Lead Status" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="lead_status" (click)="setSearchValue('lead_status')" multiple>
                                <input class="mySearchInput"
                                #lead_status_Search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="lead_status_Search">
                                <mat-option value="{{lstatus.id}}" *ngFor="let lstatus of leadStatus">{{lstatus.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1'">
                            <mat-select  placeholder="Circle" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="circle" (click)="setSearchValue('circle')">
                                <input class="mySearchInput"
                                #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="circleSearch">
                                <mat-option >All</mat-option>
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Treatment" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="treatment" (click)="setSearchValue('treatment')">
                                <input class="mySearchInput"
                                #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="treatmentSearch">
                                <mat-option >All</mat-option>
                                <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>
                    </div>
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadleads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                    <button type="button" *ngIf="myrole=='1'" class="btn btn-success ml-2" [disabled]="loading" (click)="exportLeadKeywordReport()"><i class="fa fa-file-excel"></i> Export List</button>
                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Lead Status</th>
                        <!-- <th class="tablefixcoloumn">Lead Number</th> -->
                        <th>Lead City</th>
                        <th>Circle</th>
                        <th>Treatment</th>
                        <th>Lead Time</th>
                        <th>Zoho Lead Source</th>
                        <th>Zoho Keywords</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let lead of leads;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td>
                            <span class="badge bg-azure-light">{{lead.lead_status_name}}</span>
                        </td>
                        <!-- <td class="tablefixcoloumn">{{lead.mobile}}</td> -->
                        <td>{{lead.city_name}}</td>
                        <td>{{lead.circle_name}}</td>
                        <td>{{lead.treatment_name}}</td>
                        <td>{{lead.lead_time*1000|date:'d MMM, yyyy H:m:s'}}</td>
                        <td>
                            <span>{{lead.zoho_lead_source}}</span>
                        </td>
                        <td>
                            <span >{{lead.keywords}}</span>
                        </td>
                        <td>{{lead.description}}</td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="10" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !leads.length">
                        <td colspan="10" ><i class="far fa-frown"></i> Leads not found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
              
              
          </div>
</div>